import _asyncToGenerator from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "system-ph"
};
import { useNotification } from "naive-ui";
import { useUserStore } from "@/store/user";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var userStore = useUserStore();
    var notificationAPI = useNotification();

    var resync = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return userStore.sync();

              case 3:
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);
                notificationAPI.warning({
                  content: "We could not retrieve the latest updates, some information may be oudated.",
                  closable: true
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 5]]);
      }));

      return function resync() {
        return _ref.apply(this, arguments);
      };
    }();

    if (userStore.authenticated) {
      resync();
    }

    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1);
    };
  }
});